import {apiClient} from '../apiClient';

const BACKGROUND_TASKS_BASE_URL = 'projectmanagement/api/v1/background';

export const getBackgroundTasks = async (payload: any): Promise<any> => {
  const {data} = await apiClient.post(
    `${BACKGROUND_TASKS_BASE_URL}/getmybackgroundtaskresult`,
    payload
  );
  return data;
};

export const getBackgroundTaskStatuses = async (): Promise<any> => {
  const {data} = await apiClient.get(
    `${BACKGROUND_TASKS_BASE_URL}/view/backgroundtask`
  );
  return data;
};

export const getReportDownload = async (
  id: string | number | null
): Promise<{
  isSuccess: boolean;
  data?: Blob;
  headers?: any;
  error?: unknown;
}> => {
  try {
    const response = await apiClient.get(
      `/reporting/api/v1/review/download-exl?reportId=${id}`,
      {responseType: 'blob'}
    );
    return {isSuccess: true, data: response.data, headers: response.headers};
  } catch (error) {
    return {isSuccess: false, error};
  }
};
